import React, { FC } from 'react';

import { SettingsPageShell, type SettingsPageShellProps } from './SettingsPageShell';

export interface SettingsFixedWidthPageProps extends Omit<SettingsPageShellProps, 'columnSx'> {
  /**
   * Max width of the centered content column. Defaults to 960px to match the legacy
   * `SettingsStack` column width.
   */
  maxWidth?: number | string;
}

/**
 * Centered settings page shell for block/form pages (Setup, Privacy, Secrets, …).
 *
 * The header, optional tabs, and children live inside a column that is capped at `maxWidth`
 * (960px by default) and horizontally centered, so the whole page reads as one unit. Replaces
 * the legacy `SettingsPage` + `SettingsStack` pair; keep using
 * `SettingsCard`/`SettingsCardSection`/`SettingsRow` as children. For full-width table pages use
 * {@link SettingsFullWidthPage} instead.
 */
export const SettingsFixedWidthPage: FC<SettingsFixedWidthPageProps> = ({ maxWidth = 960, ...rest }) => (
  <SettingsPageShell {...rest} columnSx={{ width: '100%', maxWidth, mx: 'auto' }} />
);
